import { twMerge } from 'tailwind-merge';
import { TextareaHTMLAttributes } from 'react';

type TextareaProps = {
    invalid?: boolean;
} & TextareaHTMLAttributes<HTMLTextAreaElement>

export const Textarea = ({invalid, disabled, ...rest}: TextareaProps) => {
    return (
        <textarea
            {...rest}
            disabled={disabled}
            className={twMerge(
                'form-textarea block w-full rounded-lg border border-surface-3 bg-surface-3 p-2.5 text-on-surface outline-hidden focus:outline-hidden transition-colors hover:bg-surface-5 focus:border-primary focus:bg-surface-5 focus:ring-primary focus-visible:ring-primary',
                disabled && 'cursor-not-allowed bg-surface-1 hover:bg-surface-1',
                invalid && 'border-error focus:border-error focus-visible:ring-error'
            )}
        />
    )
}
